/* ============================================================
   CableScan Pro — Rastreador de Cables y Comprobador de Circuito.
   Landing (slug 'cablescan'). Cargado por layout/landing.liquid (case 'cablescan').
   Bloques: countdown · galería de thumbnails · selección de bundle (.cs-bundle)
   + regalos · disparo del modal Releasit COD.
   Patrón Releasit (per-unit + quantity): cada bundle = 1 variante con precio
   POR UNIDAD; mandamos quantity = N (unidades) para que el pedido lleve las
   unidades reales (Dropi) y el total quede en el precio del bundle. Releasit lee
   input[name="quantity"] del DOM al disparar. NO usar _rsiV2.setState como primer
   path — el click nativo del botón Releasit SÍ re-lee productData.
   Ver memory/project_bundles_as_variants.
   ============================================================ */

/* ---------- COUNTDOWN ---------- */
(function () {
  var total = 3 * 3600 + 59 * 60 + 12;
  var h = document.getElementById('cd-h'), m = document.getElementById('cd-m'), s = document.getElementById('cd-s');
  if (!h || !m || !s) return;
  setInterval(function () {
    if (total <= 0) total = 4 * 3600;
    total--;
    var hh = Math.floor(total / 3600), mm = Math.floor((total % 3600) / 60), ss = total % 60;
    h.textContent = String(hh).padStart(2, '0');
    m.textContent = String(mm).padStart(2, '0');
    s.textContent = String(ss).padStart(2, '0');
  }, 1000);
})();

/* ---------- GALERÍA: thumbnail cambia imagen principal ---------- */
document.querySelectorAll('.cs-thumbs .cs-imgbox').forEach(function (t) {
  t.addEventListener('click', function () {
    document.querySelectorAll('.cs-thumbs .cs-imgbox').forEach(function (x) { x.classList.remove('active'); });
    t.classList.add('active');
    var main = document.querySelector('#main-img img');
    if (main && t.dataset.img) main.src = t.dataset.img;
  });
});

/* ============================================================
   Releasit COD trigger + selección de bundle
   ============================================================ */
var RELEASIT_SELECTORS = [
  '#rsi_buy_now_button',
  '.rsi_buy_now_button',
  '._rsi-buy-now-button',
  '._rsi-buy-now-button-app-block-hook button',
  '._rsi-buy-now-button-app-block-hook a',
  '.rsi-btn-skel'
];

function cablescanFindReleasitButton() {
  for (var i = 0; i < RELEASIT_SELECTORS.length; i++) {
    var el = document.querySelector(RELEASIT_SELECTORS[i]);
    if (el) return el;
  }
  return null;
}

var cablescanSelectedVariantId = null;
var cablescanSelectedQty = 1;

// Cada bundle = una variante con precio POR UNIDAD; mandamos la cantidad real
// (1/2/3 unidades) para que el pedido llegue con las unidades exactas (Dropi
// envía la cantidad) y el total quede en el precio del bundle. Releasit lee el
// input[name="quantity"] del DOM al disparar COD.
function cablescanSetVariantOnAllForms(variantId, qty) {
  if (!variantId) return;
  var q = parseInt(qty, 10);
  if (!q || q < 1) q = 1;
  document.querySelectorAll('form[action="/cart/add"] input[name="id"]').forEach(function (input) {
    input.value = variantId;
  });
  document.querySelectorAll('input[name="product-id"]').forEach(function (input) {
    input.value = variantId;
  });
  document.querySelectorAll('input[name="quantity"]').forEach(function (input) {
    input.value = String(q);
    input.setAttribute('value', String(q));
  });
  if (window.productData) { window.productData.quantity = q; }
  if (window.productData && Array.isArray(window.productData.variants)) {
    var v = window.productData.variants.find(function (x) { return String(x.id) === String(variantId); });
    if (v) {
      window.productData.selected_or_first_available_variant = v;
      window.productData.selected_variant = v;
      try {
        document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
        document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v } }));
      } catch (e) {}
    }
  }
}

function cablescanBundleQty(el) {
  var q = parseInt(el.getAttribute('data-bundle-qty'), 10);
  if (!q) { q = parseInt(el.getAttribute('data-units'), 10); }
  return q || 1;
}

/* ---------- Selección de bundle + regalos ---------- */
var csBundles = document.querySelectorAll('.cs-bundle');
var csGiftEbook = document.getElementById('gift-ebook');
var csGiftShip = document.getElementById('gift-ship');
var csStickyPrice = document.getElementById('sticky-price');

function csSetGift(el, on) {
  if (!el) return;
  el.classList.toggle('on', on);
  el.classList.toggle('off', !on);
  var st = el.querySelector('.cs-gstate');
  if (st) st.textContent = on ? '✓ INCLUIDO' : '—';
}

function csSelectBundle(b) {
  csBundles.forEach(function (x) { x.classList.remove('active'); });
  b.classList.add('active');
  var u = parseInt(b.dataset.units, 10) || 1;
  csSetGift(csGiftEbook, u >= 2);
  csSetGift(csGiftShip, u >= 3);
  // sticky price
  var nowEl = b.querySelector('.now'), wasEl = b.querySelector('.was');
  if (csStickyPrice && nowEl && wasEl) csStickyPrice.innerHTML = nowEl.textContent + ' <s>' + wasEl.textContent + '</s>';
  // variante seleccionada para Releasit
  var id = b.getAttribute('data-bundle-variant-id');
  if (id) {
    cablescanSelectedVariantId = id;
    cablescanSelectedQty = cablescanBundleQty(b);
    cablescanSetVariantOnAllForms(id, cablescanSelectedQty);
  }
}

csBundles.forEach(function (b) {
  b.addEventListener('click', function (e) { e.preventDefault(); csSelectBundle(b); });
});

function cablescanTriggerCOD(btn) {
  var variantId = (btn && btn.getAttribute && btn.getAttribute('data-bundle-variant-id')) || cablescanSelectedVariantId;
  var qty = (btn && btn.getAttribute && btn.getAttribute('data-bundle-qty')) || cablescanSelectedQty;
  if (variantId) cablescanSetVariantOnAllForms(variantId, qty);
  setTimeout(function () {
    var releasitBtn = cablescanFindReleasitButton();
    if (releasitBtn) { releasitBtn.click(); return; }
    var attempts = 0;
    var poll = setInterval(function () {
      attempts++;
      var b = cablescanFindReleasitButton();
      if (b) { clearInterval(poll); b.click(); return; }
      if (attempts > 30) {
        clearInterval(poll);
        if (window._rsiV2 && typeof window._rsiV2.setState === 'function') {
          try { window._rsiV2.setState({ isOpen: true }); } catch (e) {}
        }
      }
    }, 100);
  }, 50);
}
window.cablescanTriggerCOD = cablescanTriggerCOD;

/* ---------- Init: bundle preseleccionado (.active o el primero) ---------- */
(function () {
  var active = document.querySelector('.cs-bundle.active') || document.querySelector('.cs-bundle');
  if (active) csSelectBundle(active);
})();
